export default "__VITE_ASSET__D2TWsDY4__"